/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import {
    COMPANYTYPE,
    CONTENT_TYPE,
    ENTITYNAME,
    LOCALSTORAGE_KEY,
    LOGEVENT,
    MODULE,
    ORIENTATION,
    STATION_CODE,
    STORAGE_DESTINATION,TOAST_TYPES
} from "../../../framework/constant/constant";
import { ImageCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { useTranslation } from "../../../locale/useTranslation";
import * as API from "../../../framework/API/api";
import * as API_DIGITAL_SIGN from "../../../framework/API/api_digitalSign";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../../framework/utility/utilityProvider";
import { getter } from "@progress/kendo-data-query";
import RefreshButton from "../../../framework/forms/helpercomponents/buttons/RefreshButton";
import { Loader } from "../../../framework/forms/helpercomponents/Loader";
import LiveEventCard from "../../LiveEvents/components/LiveEventCard";
import { ContextMenu } from "primereact/contextmenu";
import { MenuCommandCell } from "../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";
import { ConfirmAlert, ConfirmDeleteAlert } from "../../../ConfirmAlert";
import { EnumCell } from "../../../framework/forms/helpercomponents/CustomGridCells/EnumCell";
import AddRoundButton from "../../../framework/forms/helpercomponents/buttons/AddRoundButton";
import IconSquareButton from "../../../framework/forms/helpercomponents/buttons/IconSquareButton";
import { EditPageHeader } from "../../../components/EditPageHeader";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import DigitalSignCollectionSelection from "../DigitalSignCollectionSelection";
import { useLocation, useNavigate } from "react-router-dom";
import ContentPreviewPopup from "../component/ContentPreviewPopup";
import BossDialog from "../../../components/BossDialog";
import MyCompanyCell from "../component/MyCompanyCell";
import { Input } from "@progress/kendo-react-inputs";
import DigitalSignSetResolutionForm from "../DigitalSignSetResolutionForm";
import { uploadFileInChunks } from "../../../framework/API/api_helper";
import { DigitalSignMobileContentCollection } from "../mobileView/DigitalSignMobileContentCollection";
import { uploadFileS3 } from "../../AWS/awsHelper";
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import moment from "moment";
import ToastNotification from "../../../components/ToastNotification";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);
// Cloudinary credentials
const instance = utility.getValue(LOCALSTORAGE_KEY.INSTANCE);
const cloudinaryCredentials = instance?.StorageCredentials?.Cloudinary ?? {};
// const CLOUD_NAME = "dlpms1zot";
// const UPLOAD_PRESET = "my_preset_3";
const CLOUD_NAME = cloudinaryCredentials?.cloud_name ?? "dkzax2qbn";
const UPLOAD_PRESET = cloudinaryCredentials?.preset ?? "my_preset";

export const contentMenuModel = (props) => {

    const menu = [
        {
            label: 'Options',
            items: [
                { label: 'Preview', icon: 'pi pi-fw pi-eye', command: () => props.onPreview({ ...props.dataItem }) },
                { label: 'Publish', icon: 'pi pi-fw pi-calendar', command: () => props.onPublish({ ...props.dataItem }) },
                { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
                {
                    label: `Set as ${props.dataItem?.orientation == ORIENTATION.Portrait ? utility.getKeyByValue(ORIENTATION, ORIENTATION.Landscape) : utility.getKeyByValue(ORIENTATION, ORIENTATION.Portrait)}`, icon: `pi pi-fw pi-mobile ${props.dataItem?.orientation === ORIENTATION.Landscape ? "" : "rotate-icon"}`, command: () => props.onOrientation({ ...props.dataItem })
                },
                { label: "Tag Resolution", icon: "fa fa-hdd ml-1", command: () => props.onResolution({ ...props.dataItem }) },
                { label: "Copy URL", icon: "fa-solid fa-clone", command: () => props.onCopyURL(props.dataItem) },
            ]
        }
    ]

    return menu;
}

export default function DigiSignContentCollection(props) {

    const lang = useTranslation();
    const location = useLocation();

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const companies = utility.getValue(LOCALSTORAGE_KEY.COMPANIES);
    const [isEnterpriseLogin] = useState(company?.CompanyType == COMPANYTYPE.ENTERPRISE);
    const [selectedCompany, setSelectedCompany] = useState({});

    const contextMenuRef = useRef();

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);

    const [selectedState, setSelectedState] = useState({});
    const [tileView, setTileView] = useState(true);
    const selectedFileRef = useRef([]);
    const [files, setFiles] = useState([]);
    const [displayFiles, setDisplayFiles] = useState([]);

    const [showFileProgressPopup, setShowFileProgressPopup] = useState(false);
    const [showPlaylistPopup, setShowPlaylistPopup] = useState(false);

    const [showPreview, setShowPreview] = useState(false);

    const [onEditPopup, setOnEditPopup] = useState(false);
    const [showYoutubeContentPopup, setShowYoutubeContentPopup] = useState(false);

    const selectedItemRef = useRef([]);
    const [selectedItem, _setSelectedItem] = useState({});
    const setSelectedItem = (data) => {
        selectedItemRef.current = data;
        _setSelectedItem(data);
    };

    const [showAddStreamPopup, setShowAddStreamPopup] = useState(false);
    const [addStreamDetail, setAddStreamDetail] = useState({
        name: "",
        url: ""
    });

    const [showGoogleSlidesPopup, setShowGoogleSlidesPopup] = useState(false);
    const [googleSlidesDetail, setGoogleSlidesDetail] = useState({
        name: "",
        url: ""
    });

    const [showPowerBIPopup, setShowPowerBIPopup] = useState(false);
    const [powerBIDetail, setPowerBIDetail] = useState({
        name: "",
        url: "",
        refreshEvery: 20000
    });

    const [showWebPagePopup, setShowWebPagePopup] = useState(false);
    const [webPageDetail, setWebPageDetail] = useState({
        name: "",
        url: ""
    });

    const [showCountDownPopup, setShowCountDownPopup] = useState(false);
    const [countDownDetail, setCountDownDetail] = useState({
        name: "",
        title: "",
        description: "",
        eventDate: Date.now(),
        eventTime: Date.now(),
        bgColor: "#202c33",
        textColor: "#ebebeb"
    });
    const [showRailwayPopup, setShowRailwayPopup] = useState(false);
    const [railwayStations, setRailwayStations] = useState([]);

    const [showResolution, setShowResolution] = useState(false)
    const [resolutions, setResolutions] = useState([]);

    const urlParams = new URLSearchParams(location?.search ?? "");
    const isOpenNewForm = urlParams?.get('openNewEditForm');
    const companyId = urlParams?.get('companyId');
    const [playlistCount, setPlaylistCount] = useState(0);
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setOnEditPopup(props.isUploadContent ?? false);
    }, [props.isUploadContent]);

    useEffect(() => {
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait);
        };
        updateScreenType();
        window.addEventListener('resize', updateScreenType);
        return () => window.removeEventListener('resize', updateScreenType);
    }, []);

    // open by defualt create form
    useEffect(() => {
        if (location.state?.openNewEditForm || isOpenNewForm) {
            setOnEditPopup(true);
        }
    }, [location.state?.openNewEditForm || isOpenNewForm]);

    const [filterDataItem, setFilterDataItem] = useState({
        FileType: { _id: 0, value: "All" },
        Orientation: { _id: 0, value: "All" },
        Company: { _id: 0, Name: "All" },
        Resolution: { _id: 0, Description: "All" },
    })

    const [dataItem, setDataItem] = useState({});

    useEffect(() => {
        loadData({ isSilent: false });
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let resolutionRes = await API.getDataLookup(ENTITYNAME.Resolution, { query: ["Archive", "=", false], sort: { Description: 1 } })
        setResolutions(resolutionRes.data);
        let railwayStationRes = STATION_CODE?.map((item) => { return { _id: item, Description: item } });
        setRailwayStations(railwayStationRes);
    }

    const loadData = async ({ contentType = 0, orientation = 0, isSilent = false, Company = 0, Resolution = 0 }) => {

        !isSilent && setIsLoading(true);

        setSelectedCompany(companies?.length > 0 ? companies[0] : {});

        let query = [];
        if (contentType && contentType != 0) {
            query = [...query, ["content_type", "=", contentType]];
        }

        if (orientation && orientation != 0) {
            query = [...query, ["orientation", "=", orientation]];
        }

        if (Company && Company != 0) {
            query = [...query, ["Company_id", "=", Company]];
        }

        if (Resolution && Resolution !== 0) {
            query = [...query, ["Resolution._id", "=", Resolution]];
        }

        let res = await API_DIGITAL_SIGN.getData(ENTITYNAME.DigitalSignContent, { query: query }, companyId ? [companyId] : []);
        if (res.success) {
            setIsLoading(false);
            let gridData = res.data.map((x) => {
                return {
                    ...x,
                    PosterUrl: x.thumbnailUrl ?? x.url,
                    bytes: bytesToSize(x.bytes),
                    format: x.format ?? " ",
                }
            });
            setFilterData(gridData);
            setData(gridData);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

        let playlistCountRes = await API_DIGITAL_SIGN.getCount(ENTITYNAME.DigitalSignPlaylist, { query: ["Company_id", "=", company._id] })
        setPlaylistCount(playlistCountRes?.success ? playlistCountRes.count : 0);
    }

    const onDeleteContentFromDB = async (id) => {
        let res = await API.deleteData(ENTITYNAME.DigitalSignContent, id, "_id");
        if (res.success) {
            await API.deleteData(ENTITYNAME.DigitalSignPlaylistItem, { content_id: id });
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            loadData({ contentType: filterDataItem.FileType._id });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const handleDeleteContent = async (item) => {
        let payload = {
            _id: item._id,
            publicId: item.public_id,
            resourceType: item.resource_type,
            content_type: item.content_type
        }

        let res = await API_DIGITAL_SIGN.deleteContent(payload);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            loadData({ contentType: filterDataItem.FileType._id });
        } else {
            if (res?.isDeleteFaild) {
                ConfirmAlert(() => onDeleteContentFromDB(payload._id), () => { }, "Warning", "This content is deleted or moved from storage, Do you want to delete from gallery.")
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onDeleteContent = async (item) => {

        let canDeleteContent = await API_DIGITAL_SIGN.canDeleteContent(item?._id);
        console.log(canDeleteContent);

        if (!canDeleteContent.success) {
            ConfirmAlert(() => handleDeleteContent(item), () => { }, "Warning", canDeleteContent.message);
        } else {
            handleDeleteContent(item);
        }
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    }

    const handleFiltersChange = async (e) => {
        const value = e.target.value;
        if (e.target.name == "FileType") {
            setFilterDataItem({ ...filterDataItem, [e.target.name]: value });
            await loadData({ contentType: value._id, orientation: filterDataItem.Orientation._id, Company: filterDataItem.Company._id, Resolution: filterDataItem.Resolution._id });
        } else if (e.target.name == "Orientation") {
            setFilterDataItem({ ...filterDataItem, [e.target.name]: value });
            await loadData({ contentType: filterDataItem.FileType._id, orientation: value._id, Company: filterDataItem.Company._id, Resolution: filterDataItem.Resolution._id });
        } else if (e.target.name == "Company") {
            setFilterDataItem({ ...filterDataItem, Company: value });
            await loadData({ contentType: filterDataItem.FileType._id, orientation: filterDataItem.Orientation._id, Company: value._id, Resolution: filterDataItem.Resolution._id });
        } else if (e.target.name === "Resolution") {
            setFilterDataItem({ ...filterDataItem, [e.target.name]: value });
            await loadData({
                contentType: filterDataItem.FileType._id, orientation: filterDataItem.Orientation._id, Company: filterDataItem.Company._id, Resolution: value._id
            });
        }
    };

    const onRefresh = async ({ isSilent = false }) => {
        setFilterDataItem({ FileType: { _id: 0, value: "All" }, Orientation: { _id: 0, value: "All" }, Company: { _id: 0, Name: "All" }, Resolution: { _id: 0, Description: "All" } });
        setSelectedCompany({});
        await loadData({ isSilent: isSilent });
    };

    const handleCopyURL = (dataItem) => {

        if (!dataItem || !dataItem?.url) {
            return;
        }
        navigator.clipboard.writeText(dataItem?.url).then(() => {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "URL copied successfully!" });
        }).catch((err) => {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: err.message });
        });
    };

    const onEdit = (item) => {

        switch (item.content_type) {
            case CONTENT_TYPE.YouTube:
                setShowYoutubeContentPopup(true);
                setDataItem({ ...item, FileName: item.fileName, Link: item.url });
                break;
            case CONTENT_TYPE.Stream:
                setOnEditPopup(true);
                setShowAddStreamPopup(true);
                setAddStreamDetail({ ...item, name: item.fileName, url: item.url });
                break;
            case CONTENT_TYPE.GoogleSlides:
                setOnEditPopup(true);
                setShowGoogleSlidesPopup(true);
                setGoogleSlidesDetail({ ...item, name: item.fileName, url: item.url });
                break;
            case CONTENT_TYPE.WebPage:
                setOnEditPopup(true);
                setShowWebPagePopup(true);
                setWebPageDetail({ ...item, name: item.fileName, url: item.url });
                break;
            case CONTENT_TYPE.CountDown:
                setOnEditPopup(true);
                setShowCountDownPopup(true);
                setCountDownDetail({ ...item, name: item?.fileName, title: item.countDown.title, description: item.countDown.description, eventDate: item.countDown.evenDateTime, eventTime: item.countDown.evenDateTime, bgColor: item.countDown.bgColor, textColor: item.countDown.textColor });
                break;
            case CONTENT_TYPE.PowerBI:
                setOnEditPopup(true);
                setShowPowerBIPopup(true);
                setPowerBIDetail({ ...item, name: item.fileName, url: item.url, refreshEvery: item.refreshEvery });
                break;
            default:
                console.log("Unknown resource type:");
        }
    };

    const contenMenu = [
        { label: "Publish", icon: "fa-solid fa-calendar-days fa-lg", command: () => { setShowPlaylistPopup(true) } },
        { label: "Delete", icon: "fa-solid fa-trash fa-lg", command: () => ConfirmAlert(() => onDeleteContent(selectedItemRef.current), () => { }, lang.confirm_delete_label, lang.do_you_really_want_to_delete_question) },
        {
            label: "Preview", icon: "fa-solid fa-eye fa-lg", command: () => {
                if (selectedItemRef.current?.content_type === CONTENT_TYPE.GoogleSlides) {
                    window.open(selectedItemRef.current?.url, "_blank");
                    return;
                }
                if (selectedItemRef.current?.content_type === CONTENT_TYPE.WebPage) {
                    window.open(selectedItemRef.current?.url, "_blank");
                    return;
                }
                if (selectedItemRef.current?.content_type === CONTENT_TYPE.YouTube) {
                    window.open(selectedItemRef.current?.url, "_blank");
                    return;
                }
                if (selectedItemRef.current?.content_type === CONTENT_TYPE.PowerBI) {
                    window.open(selectedItemRef.current?.url, "_blank");
                    return;
                } setShowPreview(true)
            },
            visible: [CONTENT_TYPE.YouTube, CONTENT_TYPE.Stream, CONTENT_TYPE.GoogleSlides, CONTENT_TYPE.WebPage, CONTENT_TYPE.Image, CONTENT_TYPE.PowerBI, CONTENT_TYPE.Video].includes(selectedItemRef?.current?.content_type)
        },
        {
            label: `Set as ${selectedItemRef.current?.orientation == ORIENTATION.Portrait ? utility.getKeyByValue(ORIENTATION, ORIENTATION.Landscape) : utility.getKeyByValue(ORIENTATION, ORIENTATION.Portrait)}`, icon: `fa-solid fa-${selectedItemRef.current?.orientation == ORIENTATION.Landscape ? "mobile-screen-button" : "mobile-screen-button fa-rotate-90"
                } fa-lg`, command: () => { onOrientation(selectedItemRef.current) }
        },
        { label: "Tag Resolution", icon: "fa-solid fa-hdd fa-lg", command: () => { setShowResolution(true) } },
        { label: "Copy URL", icon: "fa-solid fa-clone", command: () => handleCopyURL(selectedItemRef?.current) },
        { label: "Edit", icon: "fa-solid fa-edit", command: () => onEdit(selectedItemRef?.current), visible: [CONTENT_TYPE.YouTube, CONTENT_TYPE.Stream, CONTENT_TYPE.GoogleSlides, CONTENT_TYPE.WebPage, CONTENT_TYPE.CountDown, CONTENT_TYPE.PowerBI].includes(selectedItemRef?.current?.content_type) },
    ];

    const onContextMenu = (e, item) => {
        contextMenuRef.current.show(e);
        setSelectedItem(item);
    };

    //CONVERT BYTES TO MB
    const bytesToSize = (bytes) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes == 0) return "0 KB";
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        if (i == 0) return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    };

    const generateUniqueUploadId = () => {
        return `uqid-${Date.now()}`;
    };

    const onFileChange = async (event) => {
        const files = Array.from(event.target.files);
        let totalSizeInBytes = files.reduce((acc, x) => acc + x.size, 0);
        const finalCompanyId = isEnterpriseLogin ? selectedCompany._id : company?._id;
        let canUploadContentRes = await API_DIGITAL_SIGN.canUploadContent(totalSizeInBytes, finalCompanyId);
        if (!canUploadContentRes.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: canUploadContentRes.message });
            return;
        }
        setFiles(files);
        let displayFilesLocal = files.map((x) => { return { name: x.name, percentage: 'Uploading..', progress: 0 } })
        setDisplayFiles(displayFilesLocal);
        selectedFileRef.current = files
        setShowFileProgressPopup(true);
        uploadFiles(files, displayFilesLocal);
    }

    const uploadFilesUsingCloudinary = async (uploadFiles, displayFilesLocal) => {
        for (let i = 0; i < uploadFiles.length; i++) {

            const file = uploadFiles[i];
            const uniqueUploadId = generateUniqueUploadId();
            const chunkSize = 5 * 1024 * 1024; // Allowed upto 5MB.
            const totalChunks = Math.ceil(file.size / chunkSize);
            let currentChunk = 0;


            const uploadChunk = async (start, end) => {
                const formData = new FormData();
                formData.append('file', file.slice(start, end));
                formData.append('cloud_name', CLOUD_NAME);
                formData.append('upload_preset', UPLOAD_PRESET);
                formData.append('tags', company?._id.toString());

                const contentRange = `bytes ${start}-${end - 1}/${file.size}`;

                console.log(`Uploading chunk for uniqueUploadId: ${uniqueUploadId}; start: ${start}, end: ${end - 1}`);

                try {
                    const response = await fetch(
                        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`,
                        {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'X-Unique-Upload-Id': uniqueUploadId,
                                'Content-Range': contentRange,

                            },
                        }
                    );

                    if (!response.ok) {
                        throw new Error('Chunk upload failed.');
                    }

                    currentChunk++;

                    let percentage = Math.round((currentChunk / totalChunks) * 100);
                    var localFiles = displayFilesLocal;
                    console.log(localFiles[i]);
                    if (currentChunk < totalChunks) {
                        const nextStart = currentChunk * chunkSize;
                        const nextEnd = Math.min(nextStart + chunkSize, file.size);

                        //CALCULATE PERCENTAGE
                        console.log(percentage);


                        setDisplayFiles(prevDisplayFiles => {
                            const updatedFiles = [...prevDisplayFiles];
                            updatedFiles[i] = { ...updatedFiles[i], percentage: `${percentage}%`, progress: percentage };
                            return updatedFiles;
                        });


                        await uploadChunk(nextStart, nextEnd);

                    } else {

                        const fetchResponse = await response.json();
                        console.log(fetchResponse)

                        setDisplayFiles(prevDisplayFiles => {
                            const updatedFiles = [...prevDisplayFiles];
                            updatedFiles[i] = { ...updatedFiles[i], percentage: `100%`, progress: 100 };
                            return updatedFiles;
                        });


                        //SAVE DATA IN DB
                        await handleSubmit({ fileName: file.name, ...fetchResponse })
                        console.info('File upload complete.');
                        onRefresh({ isSilent: true });
                    }
                } catch (error) {
                    console.error('Error uploading chunk:', error);
                }
            };

            const start = 0;
            const end = Math.min(chunkSize, file.size);
            await uploadChunk(start, end);

        }

        onCloseFileUploadPopup();

    };

    const getVideoDuration = async (file) => {
        try {
            const video = document.createElement('video');

            // Create an object URL for the selected file
            const fileURL = URL.createObjectURL(file);

            video.src = fileURL;

            const videoDuration = await new Promise((resolve, reject) => {
                video.onloadedmetadata = () => {
                    resolve(video.duration);
                    URL.revokeObjectURL(fileURL);
                };

                video.onerror = () => {
                    console.log('error loading videoDuration');
                    reject(null);
                };
            });
            return videoDuration;
        } catch (e) {
            console.log(e)
            return null;
        }
    }

    const uploadFiles = async (uploadFiles, displayFilesLocal) => {


        if (uploadFiles.length == 0) {
            console.error('Please select a files.');
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select a files.' });
            return;
        }
        setOnEditPopup(false);

        const storageDestination = utility.getValue(LOCALSTORAGE_KEY.userData)?.Instance?.StorageDestination ?? STORAGE_DESTINATION.Cloudinary;

        if (storageDestination == STORAGE_DESTINATION.Cloudinary) {
            await uploadFilesUsingCloudinary(uploadFiles, displayFilesLocal);
            return;
        }

        if (storageDestination === STORAGE_DESTINATION.BossCloudMedia) {
            const credential = utility.getValue(LOCALSTORAGE_KEY.INSTANCE)?.StorageCredentials?.BossCloudMedia ?? {};
            const finalCompany = isEnterpriseLogin ? selectedCompany : company;

            for (let i = 0; i < uploadFiles.length; i++) {
                const file = uploadFiles[i];
                const fileType = file.type.split('/')[0];
                const duration = fileType === 'video' ? await getVideoDuration(file) : 10000;

                displayFilesLocal[i].progress = 0;
                displayFilesLocal[i].percentage = 'Uploading...';
                setDisplayFiles([...displayFilesLocal]);

                try {
                    const result = await uploadFileS3(file, credential, (progress) => {
                        setDisplayFiles((prevFiles) => {
                            const updatedFiles = [...prevFiles];
                            updatedFiles[i] = { ...updatedFiles[i], progress, percentage: `${progress}%` };
                            return updatedFiles;
                        });
                    }, finalCompany);

                    if (result.success) {
                        await handleSubmit({ ...result.data, fileName: file?.name, duration, bytes: file.size }, false);
                        displayFilesLocal[i].progress = 100;
                        displayFilesLocal[i].percentage = '100%';
                    } else {
                        throw new Error(result.message);
                    }
                } catch (error) {
                    displayFilesLocal[i].progress = 0;
                    displayFilesLocal[i].percentage = 'Error';
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Error uploading file: ${file.name}. ${error.message}` });
                }
                setDisplayFiles([...displayFilesLocal]);
            }

            onCloseFileUploadPopup();
            return;
        }

        // cloudinary not working in backend thats why cloudinary above other destination handled from bakend

        for (let i = 0; i < uploadFiles.length; i++) {
            await uploadFileInChunks(uploadFiles[i], async (data) => {
                if (data.success) {
                    setDisplayFiles(prevDisplayFiles => {
                        const updatedFiles = [...prevDisplayFiles];
                        updatedFiles[i] = { ...updatedFiles[i], percentage: `${data.progress}%`, progress: data.progress };
                        return updatedFiles;
                    });
                    if (data.progress == 100) {
                        const file = uploadFiles[i];
                        const fileType = file.type.split('/')[0];
                        const duration = fileType == 'video' ? await getVideoDuration(file) : null;

                        await handleSubmit({
                            ...data.result,
                            fileName: uploadFiles[i].name,
                            duration: duration,
                            bytes: file.size,
                        });
                        onRefresh({ isSilent: true });
                    }
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: data.message });
                }
            });
        }

        onCloseFileUploadPopup();

    };

    const handleYoutubeContentSubmit = async () => {
        if (!dataItem.FileName || dataItem.FileName == '') {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return;
        }
        if (!dataItem.Link || dataItem.Link == '') {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_youtube_link_error_message });
            return;
        }
        let saveItem = {
            _id: dataItem._id,
            fileName: dataItem.FileName,
            playback_url: dataItem.Link,
            secure_url: dataItem.Link,
            content_type: CONTENT_TYPE.YouTube,
            resource_type: 'video',
            bytes: 0,
            url: dataItem.Link,
        }
        await handleSubmit(saveItem);
        setShowYoutubeContentPopup(false);
        onRefresh({ isSilent: false });
        setDataItem({});
    }

    const handleSubmit = async (dataItem, isRefresh = true) => {
        const item = {
            _id: dataItem?._id,
            fileName: dataItem?.fileName,
            asset_id: dataItem?.asset_id,
            public_id: dataItem?.public_id,
            format: dataItem?.format,
            resource_type: dataItem?.resource_type,
            content_type: dataItem.content_type ?? CONTENT_TYPE[utility.convertFirstLetterToUpperCase(dataItem.resource_type)],
            bytes: dataItem?.bytes ?? 0,
            url: dataItem?.url,
            secure_url: dataItem?.secure_url,
            playback_url: dataItem?.playback_url ? dataItem.playback_url : '',
            duration: CONTENT_TYPE[utility.convertFirstLetterToUpperCase(dataItem.resource_type)] == CONTENT_TYPE.Image ? 10 * 1000 : dataItem.duration ? dataItem.duration * 1000 : 10 * 1000,//10 seconds hardcoded for image
            orientation: dataItem?.orientation ?? utility.calculateAspectRatio(dataItem?.width, dataItem?.height),
            thumbnailUrl: dataItem?.thumbnailUrl ?? utility.getThumbnailUrl(dataItem?.url, dataItem?.content_type ?? CONTENT_TYPE[utility.convertFirstLetterToUpperCase(dataItem.resource_type)]),
            countDown: dataItem?.countDown ?? {},
            refreshEvery: dataItem?.refreshEvery ?? 20000,
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id,
            fetchAhead: dataItem?.fetchAhead ?? 0,
            stationCode: dataItem?.stationCode && Object.keys(dataItem?.stationCode).length > 0 ? dataItem?.stationCode?._id : "",

        }
        console.log(item);

        const res = await API_DIGITAL_SIGN.saveData(ENTITYNAME.DigitalSignContent, item);
        if (res.success) {
            let logData = { event: LOGEVENT.CREATE_CONTENT, module: MODULE.DIGITAL_SIGN_CONTENT, data: res.data, message: res.message };
            API.SaveLogs(logData);
            if (props.isUploadContent) {
                setOnEditPopup(false);
                props?.onRefresh();
                return;
            }
            isRefresh && onRefresh({ isSilent: false });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

    }

    const onPublishContent = async (playlists) => {

        for (let i = 0; i < playlists.length; i++) {
            const playlist = playlists[i];
            let res = await API_DIGITAL_SIGN.getData(ENTITYNAME.DigitalSignPlaylistItem, { playlist_id: playlist._id });

            if (res.success) {

                //GET THE HIGHEST SEQUENCE
                let sequence = res.data.length > 0 ? res.data[res.data.length - 1].sequenceIndex + 1 : 0;
                let saveData = {
                    playlist_id: playlist._id,
                    content_id: selectedItem?._id?.toString(),
                    sequenceIndex: sequence,
                    overlay: [],
                }

                await API_DIGITAL_SIGN.saveData(ENTITYNAME.DigitalSignPlaylistItem, saveData);

            } else {
                console.log(res)
            }

        }

        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Content published in selected playlists successfully" });

        setShowPlaylistPopup(false);
    }

    const onCloseFileUploadPopup = () => {
        setShowFileProgressPopup(false);
        onRefresh({ isSilent: false });

        const disableCreatePlaylistPopup = utility.getValue(LOCALSTORAGE_KEY.disableCreatePlaylistPopup);
        if (!disableCreatePlaylistPopup && playlistCount === 0) {
            ConfirmAlert(
                () => navigate("/home/Playlist", { state: { openNewEditForm: true } }),
                () => utility.setValue(LOCALSTORAGE_KEY.disableCreatePlaylistPopup, true),
                lang.create_playlist_label,
                lang.playlist_message_label,
            );
        }
    }


    const onOrientation = async (item) => {
        let orientationValue = item?.orientation == ORIENTATION.Portrait ? ORIENTATION.Landscape : ORIENTATION.Portrait;
        let res = await API_DIGITAL_SIGN.saveData(ENTITYNAME.DigitalSignContent, { _id: item?._id, Company_id: item?.Company_id, orientation: orientationValue });
        if (res.success) {
            loadData({ contentType: filterDataItem.FileType._id });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }


    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            onPublish={() => {
                setShowPlaylistPopup(true);
                setSelectedItem(props.dataItem)
            }}
            onDelete={onDeleteContent}
            onPreview={() => {
                if (props.dataItem?.content_type === CONTENT_TYPE.GoogleSlides) {
                    window.open(props.dataItem?.url, "_blank");
                    return;
                }
                setSelectedItem(props.dataItem);
                setShowPreview(true);
            }}
            onOrientation={onOrientation}
            onResolution={() => {
                setShowResolution(true);
                setSelectedItem(props.dataItem);
            }}
            onCopyURL={() => handleCopyURL(props?.dataItem)}
            myMenuModel={contentMenuModel}
        />
    )

    //POPUP TABLE STYLE
    const tableDataStyle = {
        fontFamily: "Roboto",
        fontSize: "13px",
        fontWeight: "400",
        letterSpacing: "0.2px",
        lineHeight: "18px",
        color: "#3C4048",
        padding: "10px 10px",
        width: "360px"
    }

    const onSearch = (e) => {
        const value = e.target.value;
        if (value != "") {

            const filteredData = filterData?.length > 0 ? filterData.filter((item) => {
                return Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase())
                );
            }) : [];
            setData(filteredData);
        } else {
            setData(filterData);
        }
    }

    const onShowAddStreamPopup = () => {
        setShowAddStreamPopup(!showAddStreamPopup);
        setAddStreamDetail({ name: "", url: "" });
    }

    const onShowGoogleSlidesPopup = () => {
        setShowGoogleSlidesPopup(!showGoogleSlidesPopup);
        setGoogleSlidesDetail({ name: "", url: "" });
    }

    const onShowPowerBIPopup = () => {
        setShowPowerBIPopup(!showPowerBIPopup);
        setPowerBIDetail({ name: "", url: "", refreshEvery: 20000 });
    }

    const onShowWebPagePopup = () => {
        setShowWebPagePopup(!showWebPagePopup);
        setWebPageDetail({ name: "", url: "" });
    }

    const onShowCountDownPopup = () => {
        setShowCountDownPopup(!showCountDownPopup);
        setCountDownDetail({
            name: "",
            title: "",
            description: "",
            eventDate: Date.now(),
            eventTime: Date.now(),
            bgColor: "#202c33",
            textColor: "#ebebeb"
        });
    }

    const onAddStream = async () => {
        if (addStreamDetail.name.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Name is required" });
            return;
        }
        if (addStreamDetail.url.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Url is required" });
            return;
        }
        let saveItem = {
            _id: addStreamDetail._id,
            fileName: addStreamDetail.name,
            asset_id: "",
            public_id: addStreamDetail.name,
            format: "Stream",
            resource_type: "Stream",
            content_type: CONTENT_TYPE.Stream,
            bytes: 0,
            url: addStreamDetail.url,
            secure_url: addStreamDetail.url,
            playback_url: addStreamDetail.url,
            duration: 10,//10 seconds hardcoded for stream
            orientation: ORIENTATION.Landscape,
            thumbnailUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAZ8fePOkUqIolT6yrGJiR4vn_izK3zeytxg&s",
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id
        }
        await handleSubmit(saveItem);
        onShowAddStreamPopup();
        setOnEditPopup(false);
    }

    const isValidGoogleSlidesUrl = (url) => {
        try {
            const parsedUrl = new URL(url);

            // Check if the URL is a Google Slides presentation
            if (
                !parsedUrl.host.includes("docs.google.com") ||
                !parsedUrl.pathname.includes("/presentation/d/")
            ) {
                return { isValid: false, message: "Invalid Google Slides URL" };
            }

            // Extract query parameters
            const queryParams = parsedUrl.searchParams;

            // Check for required query parameters and their values
            const isStartTrue = queryParams.get("start") === "true";
            const isLoopFalse = queryParams.get("loop") === "false";

            // Return true if all conditions are met
            let isValid = isStartTrue && isLoopFalse
            return { isValid: isValid, message: isValid ? "Valid Google Slides URL" : "URL should have start=true and loop=false parameters" };
        } catch (e) {
            // If parsing fails, it's not a valid URL
            return { isValid: false, message: "Invalid Google Slides URL" };
        }
    }

    const onAddGoogleSlides = async () => {
        if (googleSlidesDetail.name.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Name is required" });
            return;
        }
        if (googleSlidesDetail.url.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Url is required" });
            return;
        }

        let res = isValidGoogleSlidesUrl(googleSlidesDetail.url);
        if (!res.isValid) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            return;
        }

        let saveItem = {
            _id: googleSlidesDetail._id,
            fileName: googleSlidesDetail.name,
            asset_id: "",
            public_id: googleSlidesDetail.name,
            format: "GoogleSlides",
            resource_type: "GoogleSlides",
            content_type: CONTENT_TYPE.GoogleSlides,
            bytes: 0,
            url: googleSlidesDetail.url,
            secure_url: googleSlidesDetail.url,
            playback_url: googleSlidesDetail.url,
            duration: 10,//10 seconds hardcoded for stream
            orientation: ORIENTATION.Landscape,
            thumbnailUrl: "https://static1.makeuseofimages.com/wordpress/wp-content/uploads/2022/07/google-slides-colorful.jpg",
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id
        }
        await handleSubmit(saveItem);
        onShowGoogleSlidesPopup();
        setOnEditPopup(false);
    }

    const onAddWebPage = async () => {
        if (webPageDetail.name.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Name is required" });
            return;
        }
        if (webPageDetail.url.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Url is required" });
            return;
        }


        if (!(webPageDetail.url.includes("http://") || webPageDetail.url.includes("https://"))) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Url should start with http:// or https://' });
            return;
        }

        let saveItem = {
            _id: webPageDetail?._id,
            fileName: webPageDetail.name,
            asset_id: "",
            public_id: webPageDetail.name,
            format: "html",
            resource_type: "webPage",
            content_type: CONTENT_TYPE.WebPage,
            bytes: 0,
            url: webPageDetail.url,
            secure_url: webPageDetail.url,
            playback_url: webPageDetail.url,
            duration: 10,//10 seconds hardcoded for stream
            orientation: ORIENTATION.Landscape,
            thumbnailUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQr9h0-oEsxoV8Jr1PZ9wkeBmxUERpRPzA4yg&s",
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id
        }
        await handleSubmit(saveItem);
        onShowWebPagePopup();
        setOnEditPopup(false);
    }

    const onAddCountDown = async () => {
        if (countDownDetail.name.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Name is required" });
            return;
        }
        if (countDownDetail.title.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Title is required" });
            return;
        }
        if (countDownDetail.description.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Description is required" });
            return;
        }



        let eventTime = utility.convertStringTimeToMilliseconds(moment(countDownDetail.eventTime).utc().format("HH:mm:ss"));
        let eventDate = utility.convertStringDatetoMilliseconds(moment(countDownDetail.eventDate).format("YYYY-MM-DD"));

        const evenDateTime = eventDate + eventTime;
        // check if valid date and must be greater then previous date
        if (evenDateTime < parseInt(moment().utc().format('x'))) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Event date must be greater then current date" });
            return;
        }

        let saveItem = {
            _id: countDownDetail?._id,
            fileName: countDownDetail.name,
            countDown: {
                title: countDownDetail.title,
                description: countDownDetail.description,
                evenDateTime: evenDateTime,
                bgColor: countDownDetail.bgColor,
                textColor: countDownDetail.textColor
            },
            asset_id: "",
            public_id: countDownDetail.name,
            format: "countdown",
            resource_type: "countDown",
            content_type: CONTENT_TYPE.CountDown,
            bytes: 0,
            url: "https://i.pinimg.com/736x/69/d7/f7/69d7f74fc1d464f09bf23e654638f28e.jpg",
            secure_url: "https://i.pinimg.com/736x/69/d7/f7/69d7f74fc1d464f09bf23e654638f28e.jpg",
            playback_url: "https://i.pinimg.com/736x/69/d7/f7/69d7f74fc1d464f09bf23e654638f28e.jpg",
            duration: 10,//10 seconds hardcoded for stream
            orientation: ORIENTATION.Landscape,
            thumbnailUrl: "https://i.pinimg.com/736x/69/d7/f7/69d7f74fc1d464f09bf23e654638f28e.jpg",
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id
        }
        await handleSubmit(saveItem);
        onShowCountDownPopup();
        setOnEditPopup(false);
    }

    const onAddPowerBI = async () => {
        if (powerBIDetail.name.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Name is required" });
            return;
        }
        if (powerBIDetail.url.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Url is required" });
            return;
        }

        let refreshEvery = utility.convertStringTimeToMilliseconds(moment(powerBIDetail.refreshEvery).utc().format("HH:mm:ss"));

        if (refreshEvery < 10000) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Refresh in every duration must be equalt to or greater then 10 seconds" });
            return;
        }

        let saveItem = {
            _id: powerBIDetail?._id,
            refreshEvery: refreshEvery,
            fileName: powerBIDetail.name,
            asset_id: "",
            public_id: powerBIDetail.name,
            format: "PowerBI",
            resource_type: "PowerBI",
            content_type: CONTENT_TYPE.PowerBI,
            bytes: 0,
            url: powerBIDetail.url,
            secure_url: powerBIDetail.url,
            playback_url: powerBIDetail.url,
            duration: 60,//10 seconds hardcoded for stream
            orientation: ORIENTATION.Landscape,
            thumbnailUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkpZogvXrqihDiHxsexZU5cnCt88DwfGy5OA&s",
            Company_id: isEnterpriseLogin ? selectedCompany._id : company?._id
        }
        await handleSubmit(saveItem);
        onShowPowerBIPopup();
        setOnEditPopup(false);
    }

    const handleSetResolution = async (item) => {
        let res = await API_DIGITAL_SIGN.saveData(ENTITYNAME.DigitalSignContent, { _id: selectedItemRef.current?._id, Company_id: selectedItemRef.current?.Company_id, Resolution: item })
        console.log(res);
        if (res.success) {
            let updateData = data.map(x => {
                if (x._id == selectedItemRef.current._id) {
                    return { ...selectedItemRef.current, Resolution: item };
                } else {
                    return x;
                }
            });
            setData(updateData);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message })
        }
    };

    const onShowEasternRailwayPopup = () => {
        setShowRailwayPopup(true);
    }

    const handleRailwaySubmit = async () => {
        if (!dataItem.FileName || dataItem.FileName == '') {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return;
        }
        if (!dataItem.FetchAhead) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_fetch_ahead_error_message })
            return;
        }
        if (dataItem.FetchAhead && (dataItem.FetchAhead < 0 || dataItem.FetchAhead > 6)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_fetch_ahead_error_message });
            return;
        }
        if (!dataItem.StationCode || Object.keys(dataItem.StationCode).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_station_code_error_message });
            return;
        }
        let saveItem = {
            _id: dataItem._id,
            fileName: dataItem.FileName,
            public_id: "Eastern Railway",
            format: "html",
            resource_type: "Railway Chart",
            content_type: CONTENT_TYPE.EasternRailway,
            fetchAhead: dataItem.FetchAhead ? parseInt(dataItem.FetchAhead) : 0,
            stationCode: dataItem.StationCode,
        }
        await handleSubmit(saveItem);
        setShowRailwayPopup(false);
        setOnEditPopup(false);
        setDataItem({});
    }

    return (
        <>
            {!props.isUploadContent && <>
                {isMobile ? <DigitalSignMobileContentCollection setShowPreview={setShowPreview} setSelectedItem={setSelectedItem} onDeleteContent={onDeleteContent} isLoading={isLoading} gridData={data} setOnEditPopup={setOnEditPopup} onRefresh={onRefresh} /> :
                    <div>
                        <div className="row m-1">
                            <div className="col-8">
                                <h1
                                    className="page-title txt-color-bludeDark"
                                    style={{ margin: "10px 0" }}
                                >
                                    <i
                                        className="fa fa-tv"
                                        style={{ fontSize: "20px", color: "GrayText" }}
                                    ></i>
                                    <span
                                        style={{
                                            fontFamily: "sans-serif",
                                            paddingLeft: "5px",
                                            letterSpacing: "0.5px",
                                        }}
                                    >
                                        Total Contents - {data?.length}
                                    </span>
                                </h1>
                            </div>
                            <div className="col-4 d-flex align-items-center justify-content-end">
                                <div className="pointer p-1" onClick={() => setTileView(!tileView)}
                                    title={tileView ? `${lang.grid_view_label}` : `${lang.tile_view_label}`}
                                >
                                    <i className={`fas ${tileView ? "fa-table-cells" : "fa-table-list"} fa-xl`} />
                                </div>
                            </div>
                        </div>
                        <div className="flex-container ml-2 mr-2">
                            <div className="mt-3">
                                <AddRoundButton onClick={() => { setOnEditPopup(true) }} />
                                <RefreshButton onClick={() => onRefresh({ isSilent: false })} />
                            </div>
                            <div className="flex-container-reverse flex-item-auto mr-4">
                                <div className="input-group input-group w-300 martb" >
                                    <input
                                        type="text"
                                        className="form-control shadow-inset-2 pt-0 pb-0"
                                        id="searchInput"
                                        placeholder={lang.search_button_text}
                                        onChange={onSearch}
                                        onFocus={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(true);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            if (props.setOutSideFocus) {
                                                props.setOutSideFocus(false);
                                            }
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div className="mr-2" style={{ marginTop: '-10px', width: '150px' }}>
                                    <label htmlFor="TabView">{lang.orientation_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={[
                                            { _id: 0, value: "All" },
                                            ...Object.keys(ORIENTATION).map((key) => {
                                                return { _id: ORIENTATION[key], value: key }
                                            })
                                        ]}
                                        name="Orientation"
                                        textField="value"
                                        dataItemKey="_id"
                                        value={filterDataItem.Orientation}
                                        onChange={handleFiltersChange}
                                    />
                                </div>
                                <div className="mr-2" style={{ marginTop: '-10px', width: '150px' }}>
                                    <label htmlFor="TabView">{lang.content_type_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={[
                                            { _id: 0, value: "All" },
                                            ...Object.keys(CONTENT_TYPE).map((key) => {
                                                return { _id: CONTENT_TYPE[key], value: key }
                                            })
                                        ]}
                                        name="FileType"
                                        textField="value"
                                        dataItemKey="_id"
                                        value={filterDataItem.FileType}
                                        onChange={handleFiltersChange}
                                    />
                                </div>
                                <div className="mr-2" style={{ marginTop: '-10px', width: '150px' }}>
                                    <label htmlFor="TabView">{lang.resolution_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={[
                                            { _id: 0, Description: "All" },
                                            ...resolutions,
                                        ]}
                                        name="Resolution"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={filterDataItem.Resolution}
                                        onChange={handleFiltersChange}
                                    />
                                </div>
                                {isEnterpriseLogin && <div className="mr-2" style={{ marginTop: '-10px', width: '150px' }}>
                                    <label htmlFor="TabView">{lang.company_label}</label>
                                    <DropDownList
                                        style={{ backgroundColor: "white" }}
                                        data={[
                                            { _id: 0, Name: "All" },
                                            ...companies
                                        ]}
                                        name="Company"
                                        textField="Name"
                                        dataItemKey="_id"
                                        value={filterDataItem.Company}
                                        onChange={handleFiltersChange}
                                    />
                                </div>}
                            </div>
                        </div>
                        <div className="row mr-1" style={{ height: "74vh" }}>
                            {isLoading ? (
                                <Loader height={"65vh"} />
                            ) : tileView ? (
                                data && data.length == 0 ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%', width: '100%', fontWeight: "500", color: "grey" }}><AddRoundButton onClick={() => { setOnEditPopup(true) }} /> Upload New Content</div> :
                                    <div style={{ height: "100%", width: "100%", overflow: "auto", display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))' }}>{
                                        data.map((content, index) => (
                                            <LiveEventCard
                                                item={content}
                                                showLive={false}
                                                cardInline={2}
                                                tooltip={`${content.fileName +
                                                    "\n" +
                                                    content.bytes +
                                                    "\n" +
                                                    content.format +
                                                    "\n"}`
                                                }
                                                title={content.fileName}
                                                description={content.bytes}
                                                subDescription={content.addOn ? `Added on : ${utility.convertMilisecondsToDateTimeString(content.addOn)}` : ''}
                                                subDescription2={content.format}
                                                index={index}
                                                onContextMenu={onContextMenu}
                                                showResolutionCard={true}
                                                showIcon={true}
                                                showCompanyName={true}
                                            />
                                        ))
                                    }</div>) : (
                                <Grid
                                    style={{ margin: "10px", height: "100%", width: "100%" }}
                                    data={data.map((item) => ({
                                        ...item,
                                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                                    }))}
                                    dataItemKey={DATA_ITEM_KEY}
                                    selectedField={SELECTED_FIELD}
                                    resizable={true}
                                    selectable={{
                                        enabled: true,
                                        cell: false,
                                        mode: "multiple",
                                    }}
                                >
                                    <Column cell={MyCommandCell} width={"60px"} locked={true} />
                                    <Column
                                        field="PosterUrl"
                                        title={"Thumbnail"}
                                        editable={false}
                                        cell={ImageCell}
                                        width={"100px"}
                                    />
                                    <Column
                                        field="fileName"
                                        title={"File Name"}
                                        editable={false}
                                        width={200}
                                    />
                                    <Column
                                        field="bytes"
                                        title={"Size"}
                                        editable={false}
                                        width={200}
                                    />

                                    <Column
                                        field="content_type"
                                        title={"Type"}
                                        editable={false}
                                        cell={EnumCell}
                                        width={200}
                                    />

                                    <Column
                                        field="orientation"
                                        title={"Orientation"}
                                        editable={false}
                                        cell={EnumCell}
                                        width={200}
                                    />

                                    <Column
                                        field="format"
                                        title={"Format"}
                                        editable={false}
                                        width={200}
                                    />

                                    <Column
                                        field="Resolution.Description"
                                        title={"Resolution"}
                                        editable={false}
                                        width={200}
                                    />

                                    {isEnterpriseLogin && <Column
                                        field="Company_id"
                                        title={"Company"}
                                        cell={MyCompanyCell}
                                        width={200}
                                    />}

                                </Grid>
                            )}
                        </div>
                    </div>}
            </>}
            {showFileProgressPopup && <BossDialog
                title={"File Progress"}
                onClose={onCloseFileUploadPopup}
                width={isMobile ? "95%" : "750px"}
            >
                <div>

                    <table className="table mt-2">
                        <thead>
                            <tr>
                                <th scope="col">{lang.file_name_column}</th>
                                <th scope="col">{lang.progress_column}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayFiles?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={tableDataStyle}>
                                            {`${item?.name?.length > 50 ? item?.name?.substring(0, 50) + "..." : item?.name}`}
                                        </td>
                                        <td style={tableDataStyle}>
                                            <ProgressBar
                                                label={(props) => {
                                                    return <strong>{item?.percentage}</strong>;
                                                }}
                                                labelPlacement='center'
                                                progressStyle={{ backgroundColor: "green" }}
                                                value={item?.progress}
                                                style={{ width: "100%" }}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
            </BossDialog>}

            {/* content type selector */}
            {onEditPopup && <BossDialog width={isMobile ? "95%" : ((showAddStreamPopup || showPowerBIPopup || showCountDownPopup || showWebPagePopup || showGoogleSlidesPopup) && "400px")} title={showPowerBIPopup ? 'Add Power BI' : showCountDownPopup ? 'Add Countdown' : showWebPagePopup ? 'Add Web Page' : showGoogleSlidesPopup ? 'Add Google Slides' : showAddStreamPopup ? "Add Stream" : "Select Content Type"} onClose={() => { (showGoogleSlidesPopup ? onShowGoogleSlidesPopup() : showAddStreamPopup ? onShowAddStreamPopup() : setOnEditPopup(false)); (props.onClose && props.onClose()) }} >
                {isEnterpriseLogin && <div className="mb-2">
                    <label htmlFor="TabView">{lang.company_label} *</label>
                    <DropDownList
                        data={companies}
                        name="Company"
                        textField="Name"
                        dataItemKey="_id"
                        value={selectedCompany}
                        onChange={(e) => setSelectedCompany(e.target.value)}
                    />
                </div>}
                {showPowerBIPopup ?
                    <div>
                        <EditPageHeader showTitle={false} saveButtonTitle={'Add'} onCancel={onShowPowerBIPopup} onSubmit={onAddPowerBI} />
                        {/* input to take name of stream */}
                        <div className="d-flex flex-column">
                            <Input
                                type="text"
                                name="Name"
                                label="Name"
                                value={powerBIDetail.name}
                                onChange={(e) => setPowerBIDetail({
                                    ...powerBIDetail,
                                    name: e.target.value
                                })}
                            />
                            <Input
                                type="text"
                                name="Url"
                                label="Url"
                                value={powerBIDetail.url}
                                onChange={(e) => setPowerBIDetail({
                                    ...powerBIDetail,
                                    url: e.target.value
                                })}
                                className="mb-2"
                            />
                            <TimePickerWithFormat
                                className="form-control form-control-sm"
                                name="Time"
                                label="Refresh in every"
                                isWithFrames={false}
                                value={moment(powerBIDetail.refreshEvery).utc().format("HH:mm:ss")}
                                onChange={(e) => setPowerBIDetail({
                                    ...powerBIDetail,
                                    refreshEvery: utility.convertStringTimeToMilliseconds(e.target.value)
                                })}
                            />
                            <div className="mt-2">
                                <div className="mb-2" style={{ fontWeight: "bold" }}>How to Publish Power BI Report:</div>
                                <ol style={{ fontSize: "14px", marginLeft: "12px", color: "#696868" }}>
                                    <li>Prepare your report in <strong>Power BI Desktop.</strong></li>
                                    <li>Publish to Power BI Service: <strong>Publish your report from Power BI Desktop to Power BI Service.</strong> Click on the Home tab, Select Publish from the ribbon,Choose the workspace where you want to publish your report and hit publish. This uploads your report to the Power BI Service.</li>
                                    <li>Generate the embed code: Now that your report is in the Power BI Service,Navigate to your report in Power BI Service, <strong>Go to Power BI Service and log in</strong><a
                                        href="https://app.powerbi.com/home?culture=en-us&country=us&ScenarioId=Signup&experience=power-bi"
                                        className="btn btn-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Power BI Services
                                    </a></li>
                                    <li>Publish to Web, Click on File in the top menu, Select Embed report and then Publish to web (public), You’ll see a warning about making your report public. If everything looks good, click Create embed code.</li>
                                    <li>Customize the embed code- Customize the size and settings of your embedded report as needed.</li>
                                    <li>Once the embed code is created, copy the URL provided first, paste it into the URL input field.</li>
                                </ol>
                            </div>
                        </div>
                    </div> : showGoogleSlidesPopup ?
                        <div>
                            <EditPageHeader showTitle={false} saveButtonTitle={'Add'} onCancel={onShowGoogleSlidesPopup} onSubmit={onAddGoogleSlides} />
                            {/* input to take name of stream */}
                            <div className="d-flex flex-column">
                                <Input
                                    type="text"
                                    name="Name"
                                    label="Name"
                                    value={googleSlidesDetail.name}
                                    onChange={(e) => setGoogleSlidesDetail({
                                        ...googleSlidesDetail,
                                        name: e.target.value,
                                        url: googleSlidesDetail.url
                                    })}
                                />
                                <Input
                                    type="text"
                                    name="Url"
                                    label="Url"
                                    value={googleSlidesDetail.url}
                                    onChange={(e) => setGoogleSlidesDetail({
                                        ...googleSlidesDetail,
                                        name: googleSlidesDetail.name,
                                        url: e.target.value
                                    })}
                                />
                                <div className="mt-2">
                                    <div className="mb-2" style={{ fontWeight: "bold" }}>{lang.how_to_create_google_slide}</div>
                                    <ol style={{ fontSize: "14px", marginLeft: "12px", color: "#696868" }}>
                                        <li>{lang.go_to_google_slide}<a
                                            href="https://docs.google.com/presentation/u/0/"
                                            className="btn btn-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Open Google Slides
                                        </a></li>
                                        <li>{lang.click_on_homepage_template_option_available}</li>
                                        <li>{lang.creating_presentation}</li>
                                        <li>After completing your presentation, go to the File menu, click Share, and select Publish to Web. Read all the steps carefully and ensure that the <strong>"Start slideshow as soon as the player loads"</strong> checkbox is selected, as this option is mandatory. </li>
                                        <li>{lang.copy_url_of_google_slide}</li>
                                    </ol>
                                </div>
                            </div>
                        </div> : showCountDownPopup ? <div>
                            <EditPageHeader showTitle={false} saveButtonTitle={'Add'} onCancel={onShowCountDownPopup} onSubmit={onAddCountDown} />
                            {/* input to take name of stream */}
                            <div className="d-flex flex-column">
                                <Input
                                    type="text"
                                    name="Name"
                                    label="Name"
                                    value={countDownDetail.name}
                                    onChange={(e) => setCountDownDetail({
                                        ...countDownDetail,
                                        name: e.target.value,
                                    })}
                                />
                                <Input
                                    type="text"
                                    name="Title"
                                    label="Title"
                                    value={countDownDetail.title}
                                    onChange={(e) => setCountDownDetail({
                                        ...countDownDetail,
                                        title: e.target.value
                                    })}
                                />
                                <Input
                                    type="text"
                                    name="Description"
                                    label="Description"
                                    value={countDownDetail.description}
                                    onChange={(e) => setCountDownDetail({
                                        ...countDownDetail,
                                        description: e.target.value
                                    })}
                                />
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginTop: "10px" }}>
                                    <div>
                                        <label>Event date</label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            name="FromDate"
                                            value={moment(countDownDetail.eventDate).format("yyyy-MM-DD")}
                                            onChange={(e) => {
                                                setCountDownDetail({
                                                    ...countDownDetail,
                                                    eventDate: parseInt(moment(e.target.value, "yyyy-MM-DD").format('x')),
                                                })
                                            }
                                            }
                                        />
                                    </div>
                                    <TimePickerWithFormat
                                        className="form-control form-control-sm"
                                        name="Time"
                                        label="Event time"
                                        isWithFrames={false}
                                        value={moment(countDownDetail.eventTime).utc().format("HH:mm:ss")}
                                        onChange={(e) => setCountDownDetail({
                                            ...countDownDetail,
                                            eventTime: utility.convertStringTimeToMilliseconds(e.target.value)
                                        })}
                                    />
                                </div>
                                {/* backgroundColor input */}
                                <div style={{ display: "flex", gap: "60px", marginTop: "20px" }}>
                                    <div>
                                        <label style={{ fontSize: "14px", color: " #333" }}>Background color</label>
                                        <div style={{ display: " flex", alignItems: " center" }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    border: '1px solid grey',
                                                    borderRadius: '4px',
                                                    padding: '2px',
                                                    width: '20px',
                                                    height: '20px',
                                                    justifyContent: 'center',
                                                    backgroundColor: countDownDetail.bgColor,
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => document.getElementById('colorPicker').click()}
                                            >
                                                <input
                                                    id="colorPicker"
                                                    type="color"
                                                    name="BackgroundColor"
                                                    value={countDownDetail.bgColor}
                                                    onChange={(e) =>
                                                        setCountDownDetail({
                                                            ...countDownDetail,
                                                            bgColor: e.target.value,
                                                        })
                                                    }
                                                    style={{
                                                        opacity: 0,
                                                        zIndex: -1,
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </div>
                                            <span
                                                style={{
                                                    position: "relative",
                                                    left: "5px",
                                                    fontSize: "14px",
                                                    fontFamily: "Arial, sans-serif",
                                                    color: "black",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => document.getElementById('colorPicker').click()}
                                            >{countDownDetail.bgColor}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: "14px", color: " #333" }}>Text color</label>
                                        <div style={{ display: " flex", alignItems: " center" }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    border: '1px solid grey',
                                                    borderRadius: '4px',
                                                    padding: '2px',
                                                    width: '20px',
                                                    height: '20px',
                                                    justifyContent: 'center',
                                                    backgroundColor: countDownDetail.textColor,
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => document.getElementById('txtColorPicker').click()}
                                            >
                                                <input
                                                    id="txtColorPicker"
                                                    type="color"
                                                    name="textColor"
                                                    value={countDownDetail.textColor}
                                                    onChange={(e) =>
                                                        setCountDownDetail({
                                                            ...countDownDetail,
                                                            textColor: e.target.value,
                                                        })
                                                    }
                                                    style={{
                                                        opacity: 0,
                                                        zIndex: -1,
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </div>
                                            <span
                                                style={{
                                                    position: "relative",
                                                    left: "5px",
                                                    fontSize: "14px",
                                                    fontFamily: "Arial, sans-serif",
                                                    color: "black",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => document.getElementById('txtColorPicker').click()}
                                            >{countDownDetail.textColor}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : showWebPagePopup ? <div>
                            <EditPageHeader showTitle={false} saveButtonTitle={'Add'} onCancel={onShowWebPagePopup} onSubmit={onAddWebPage} />
                            {/* input to take name of stream */}
                            <div className="d-flex flex-column">
                                <Input
                                    type="text"
                                    name="Name"
                                    label="Name"
                                    value={webPageDetail.name}
                                    onChange={(e) => setWebPageDetail({
                                        ...webPageDetail,
                                        name: e.target.value,
                                        url: webPageDetail.url
                                    })}
                                />
                                <Input
                                    type="text"
                                    name="Url"
                                    label="Url"
                                    value={webPageDetail.url}
                                    onChange={(e) => setWebPageDetail({
                                        ...webPageDetail,
                                        name: webPageDetail.name,
                                        url: e.target.value
                                    })}
                                />
                            </div>
                        </div> : showAddStreamPopup ?
                            <div>
                                <EditPageHeader showTitle={false} saveButtonTitle={'Add'} onCancel={onShowAddStreamPopup} onSubmit={onAddStream} />
                                {/* input to take name of stream */}
                                <div className="d-flex flex-column">
                                    <Input
                                        type="text"
                                        name="Name"
                                        label="Name"
                                        value={addStreamDetail.name}
                                        onChange={(e) => setAddStreamDetail({
                                            ...addStreamDetail,
                                            name: e.target.value,
                                            url: addStreamDetail.url
                                        })}
                                    />
                                    <Input
                                        type="text"
                                        name="Url"
                                        label="Url"
                                        value={addStreamDetail.url}
                                        onChange={(e) => setAddStreamDetail({
                                            ...addStreamDetail,
                                            name: addStreamDetail.name,
                                            url: e.target.value
                                        })}
                                    />
                                </div>
                            </div>
                            : <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "1fr 1fr 1fr" }}>
                                <div>
                                    <IconSquareButton
                                        name={'Image'}
                                        title={'Add Images'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        icon={'fa-image'}
                                        iconSize={'50px'}
                                        onFileChange={onFileChange}
                                        inputField={true}
                                        buttonType={'file'}
                                        accept={'image/*'}
                                        backgroundColor={'#007c7c'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Video'}
                                        title={'Add Videos'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        icon={'fa-video'}
                                        iconSize={'50px'}
                                        onFileChange={onFileChange}
                                        inputField={true}
                                        buttonType={'file'}
                                        accept={'video/*'}
                                        backgroundColor={'#c80096'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Stream'}
                                        title={'Add Stream'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        onClick={onShowAddStreamPopup}
                                        icon={'fa-stream'}
                                        iconSize={'50px'}
                                        backgroundColor={'purple'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'WebPage'}
                                        title={'Add WebPage'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        onClick={onShowWebPagePopup}
                                        icon={'fa-globe'}
                                        iconSize={'50px'}
                                        backgroundColor={'#4da5e6'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Countdown'}
                                        title={'Add Countdown'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        onClick={onShowCountDownPopup}
                                        icon={'fa-clock'}
                                        iconSize={'50px'}
                                        backgroundColor={'#202c33'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Youtube'}
                                        title={'Add Youtube Link'}
                                        width={"100px"}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        icon={'fa-play ml-2'}
                                        iconSize={'40px'}
                                        onClick={() => {
                                            setShowYoutubeContentPopup(true);
                                            setOnEditPopup(false);
                                        }}
                                        backgroundColor={'#ff002f'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Power BI'}
                                        title={'Add Power BI'}
                                        width={"100px"}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        icon={'fa-chart-simple'}
                                        iconSize={'40px'}
                                        onClick={onShowPowerBIPopup}
                                        backgroundColor={'#f7c931'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Google Slides'}
                                        title={'Add Google Slides'}
                                        width={'80px'}
                                        height={'100px'}
                                        borderRadius={'5px'}
                                        onClick={onShowGoogleSlidesPopup}
                                        icon={'fa-slideshare'}
                                        iconSize={'50px'}
                                        backgroundColor={'#fcbb03'}
                                    />
                                </div>
                                <div>
                                    <IconSquareButton
                                        name={'Eastern Railway'}
                                        title={'Add Eastern Railway'}
                                        width={'100px'}
                                        height={'100px'}
                                        borderRadius={'10px'}
                                        onClick={onShowEasternRailwayPopup}
                                        icon={'fa-subway'}
                                        iconSize={'60px'}
                                        backgroundColor={'#EE1B24'}
                                    />
                                </div>
                            </div>
                }
                <div className="p-1 mt-2 border rounded">
                    <h6 className="fw-bold">Note: For Video</h6>
                    <ol className="p-2 ml-2">
                        <li>
                            {lang.large_video_compress_message} -{" "}
                            <a href="https://www.veed.io/tools/video-compressor" target="_blank" rel="noopener noreferrer">Video Compressor</a>
                        </li>
                        <li>
                            {lang.video_format_mpeg_message} -{" "}
                            <a href="https://www.veed.io/convert/mp4-to-mpeg" target="_blank" rel="noopener noreferrer">MP4 to MPEG Converter</a>
                        </li>
                    </ol>
                </div>
            </BossDialog>}

            <ContextMenu model={contenMenu} ref={contextMenuRef} />

            {showPlaylistPopup && <DigitalSignCollectionSelection entityname={ENTITYNAME.DigitalSignPlaylist} closeForm={() => { setShowPlaylistPopup(false) }} setDataList={onPublishContent} title={'Select Playlist'} width={"800px"} />}

            {/* YouTube Content Popup */}
            {showYoutubeContentPopup && <BossDialog
                title={"Add YouTube Content"}
                onClose={() => { setShowYoutubeContentPopup(false); (props.onClose && props.onClose()) }}
                width={"500px"}
            >
                <EditPageHeader onSubmit={handleYoutubeContentSubmit} saveButtonTitle={'Add'} onCancel={() => setShowYoutubeContentPopup(false)} showTitle={false} />

                <div className="form-group mt-2">
                    <label htmlFor="">{lang.name_label} *</label>
                    <input type="text" name="FileName" className="form-control" placeholder="Name" value={dataItem.FileName} onChange={onChange} />
                </div>

                <div className="form-group">
                    <label htmlFor="">{lang.link_label} *</label>
                    <input type="text" name="Link" className="form-control" placeholder="Youtube Link" value={dataItem.Link} onChange={onChange} />
                </div>

            </BossDialog>}

            {showPreview && <ContentPreviewPopup selectedItem={selectedItem} onClose={() => setShowPreview(false)} />}
            {showResolution && <DigitalSignSetResolutionForm onClose={() => setShowResolution(false)} handleSetResolution={handleSetResolution} item={selectedItem} />}
            {showRailwayPopup && <BossDialog title={"Add Eastern Railway"} onClose={() => { setShowRailwayPopup(false); (props.onClose && props.onClose()) }} width={"500px"}>
                <EditPageHeader onSubmit={handleRailwaySubmit} onCancel={() => setShowRailwayPopup(false)} showTitle={false} />
                <div className="form-group mt-2">
                    <label htmlFor="">{lang.name_label} *</label>
                    <input type="text" name="FileName" className="form-control form-control-sm" value={dataItem.FileName} onChange={onChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="">{lang.fetch_ahead_label} *</label>
                    <input type="number" min="0" max="6" name="FetchAhead" className="form-control form-control-sm" value={dataItem.FetchAhead} onChange={onChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="">{lang.station_code_label} *</label>
                    <DropDownList
                        data={railwayStations}
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.StationCode}
                        onChange={onChange}
                        name="StationCode"
                    />
                </div>
            </BossDialog>}
        </>
    );
}